export default __webpack_public_path__ + "static/media/config.889f3471.svg";